import { render } from "./User-Edit.vue?vue&type=template&id=4227b3da&scoped=true"
import script from "./User-Edit.vue?vue&type=script&lang=js"
export * from "./User-Edit.vue?vue&type=script&lang=js"

import "./User-Edit.vue?vue&type=style&index=0&id=4227b3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4227b3da"]])

export default __exports__